import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    currentClass: JSON.parse(localStorage.getItem('currentClass') || 'null')
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isTeacher: state => state.user && state.user.role === 'teacher',
    isStudent: state => state.user && state.user.role === 'student',
    isAdmin: state => state.user && state.user.role === 'admin',
    userRole: state => state.user ? state.user.role : null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_CURRENT_CLASS(state, cls) {
      state.currentClass = cls
      localStorage.setItem('currentClass', JSON.stringify(cls))
    },
    LOGOUT(state) {
      state.token = ''
      state.user = null
      state.currentClass = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('currentClass')
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const res = await axios.post('/auth/login', { username, password })
      const { access_token, user } = res.data
      commit('SET_TOKEN', access_token)
      commit('SET_USER', user)
      return user
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    async refreshProfile({ commit, state }) {
      if (!state.token) return
      const res = await axios.get('/auth/profile', {
        headers: { Authorization: `Bearer ${state.token}` }
      })
      commit('SET_USER', res.data.user)
    }
  }
})
